module.exports = __webpack_public_path__ + "static/media/98b53696-e522-4336-aaf1-ab59ac746ec1_1.ac1441ee435f0597e2a1af1489c49fdc.136f6a59.jpeg";